// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"152":"rails-admin","331":"market"}[chunkId] + "-" + {"152":"7c55669d","331":"ec11dfa5"}[chunkId] + ".css";
};